import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';
import { SearchReportRequestDetails } from 'src/app/Models/report-status.model';

@Injectable({
  providedIn: 'root'
})
export class RequestStatusService {

  private url: string;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient,
    private appInsights: AppInsightsService) {
    this.url = appConfigService.get('apiUrl');
  }
  getReportByDateRange(jsonData: any) {
      return this.http.post(this.url + '/Reports/GetReportByDateRange', jsonData).pipe(
      map(response => <any>response),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
  }

  GetBillingAdjustmentStatusRequestDetailReports(adjReqId: number) {
    let params = new HttpParams().set('AdjReqId', adjReqId);
    return this.http.get(this.url + '/Reports/GetBillingAdjustmentRequestDetailReports', { params }).pipe(
      map(response => <any>response),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
   }

   exportReportToExcel(jsonData: any) {
  return this.http.post(this.url + '/Reports/ExportReportToExcel', jsonData, {
    responseType: 'blob' 
  }).pipe(
    map((response: Blob) => {
      return response;
    }),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(() => response);
    })
  );
}

exportFormPR38(jsonData: any) {
  return this.http.post(this.url + '/BillingAdjustment/ExportFormPR38', jsonData, {
    responseType: 'blob'
  }).pipe(
    map((response: Blob) => response),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(() => error);
    })
  );
}




      // Validate AdjReqId with API before generating PDF
async validateAdjReqId(adjReqId: string): Promise<boolean> {
  // Call the API and check if the response is valid
  try {
    const params = new HttpParams().set('AdjReqId', adjReqId);
    const response = await this.http.get<any>(this.url + '/Reports/GetValidateAdjReqID', { params }).toPromise();
    // You can adjust the logic below based on what a "valid" response means
    return !!response;
  } catch (error) {
    this.appInsights.logException(error);
    return false;
  }
}

   
  DownloadUploadedFiles(adjReqId: number): Observable<Blob> {
    return this.http.get(this.url + '/BillingAdjustment/DownloadFilesUploaded' + '?AdjReqId=' + adjReqId, {
      responseType: 'blob' 
    }).pipe(
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response); 
      })
    );
  }

  /**
   * Fetches invoice data for the given Adjustment Request ID for PDF generation.
   * This is a skeleton method; the backend endpoint should return all fields needed for the PDF.
   * @param adjReqId The Adjustment Request ID
   * @returns Promise<any> containing the invoice data object
   */
  async getInvoiceDataForAdjReqId(adjReqId: string): Promise<any> {
    try {
      const params = new HttpParams().set('AdjReqId', adjReqId);
      // TODO: Replace endpoint with actual backend API when available
      const response = await this.http.get<any>(this.url + '/Reports/GetInvoiceData', { params }).toPromise();
      return response;
    } catch (error) {
      this.appInsights.logException(error);
      return null;
    }
  }
}
